import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";

import InteracBotAvatar from "./components/InteracBotAvatar/InteracBotAvatar";
import LearningOptions from "./components/LevelOne/LevelOne";
import LinkList from "./components/LinkList/LinkList";
import MoreQuestions from "./components/MoreQuestions/MoreQuestions";
import Feedback from "./components/Feedback/Feedback";

import ConsumerProducts from "./components/ConsumerProducts/ConsumerProducts";

import EtransferOptions from "./components/EtransferOptions/EtransferOptions";
import AutodespositOptions from "./components/AutodespositOptions/AutodespositOptions";
import RequestMoneyOptions from "./components/RequestMoneyOptions/RequestMoneyOptions";
import IntlTransfersOptions from "./components/IntlTransfersOptions/IntlTransfersOptions";
import EtransferSecurityOptions from "./components/EtransferSecurityOptions/EtransferSecurityOptions";

import DebitOptions from "./components/DebitOptions/DebitOptions";
import ContactlessPaymentsOptions from "./components/ContactlessPaymentsOptions/ContactlessPaymentsOptions";
import TransitOpenPaymentsOptions from "./components/TransitOpenPaymentsOptions/TransitOpenPaymentsOptions";
import EcommercePaymentsOptions from "./components/EcommercePaymentsOptions/EcommercePaymentsOptions";
import AbmWithdrawalsOptions from "./components/AbmWithdrawalsOptions/AbmWithdrawalsOptions";

import ApplePayOptions from "./components/ApplePayOptions/ApplePayOptions";
import GooglePayOptions from "./components/GooglePayOptions/GooglePayOptions";
import SamsungPayOptions from "./components/SamsungPayOptions/SamsungPayOptions";
import OnlinePaymentsOptions from "./components/OnlinePaymentsOptions/OnlinePaymentsOptions";

import BusinessProducts from "./components/BusinessProducts/BusinessProducts";
import EtransferOptionsBus from "./components/BusinessProducts/EtransferOptionsBus/EtransferOptionsBus";

import EufOptionsBus from "./components/BusinessProducts/EufOptionsBus/EufOptionsBus";
import AutodepositOptionsBus from "./components/BusinessProducts/EufOptionsBus/AutodepositOptionsBus/AutodepositOptionsBus";
import RequestMoneyOptionsBus from "./components/BusinessProducts/EufOptionsBus/RequestMoneyOptionsBus/RequestMoneyOptionsBus";
import BulkDisbursementsOptions from "./components/BusinessProducts/EufOptionsBus/BulkDisbursementsOptions/BulkDisbursementsOptions";

import DebitOptionsBus from "./components/BusinessProducts/DebitOptionsBus/DebitOptionsBus";
import ContactlessOptionsBus from "./components/BusinessProducts/ContactlessOptionsBus/ContactlessOptionsBus";
import MobileOptionsBus from "./components/BusinessProducts/MobileOptionsBus/MobileOptionsBus";
import OnlineOptionsBus from "./components/BusinessProducts/OnlineOptionsBus/OnlineOptionsBus";
import AbmOptionsBus from "./components/BusinessProducts/AbmOptionsBus/AbmOptionsBus";

const config = {
  botName:  "InteracBot Help",
  initialMessages: [
    createChatBotMessage("Hi there! You can use this tool to help you find answers to your questions about INTERAC products and services."),
    createChatBotMessage("Please select one of the options below.",
    {
      widget: "learningOptions",
    }),
  ],
  customStyles: {
    botMessageBox: {
      backgroundColor: "#000000",
    },
    chatButton: {
      backgroundColor: "#f0b51c",
    },
  },
  customComponents: {
    // Replaces the default header
   header: () => <div className="interacAvatar-header"><InteracBotAvatar /><em>Interac</em>Bot Help</div>,
   botAvatar: (props) => <InteracBotAvatar {...props} />,
  },
  widgets: [
    {
      widgetName: "learningOptions",
      widgetFunc: (props) => <LearningOptions {...props} />,
    },

    {
      widgetName: "MoreQuestions",
      widgetFunc: (props) => <MoreQuestions {...props} />,
    },
    {
      widgetName: "Feedback",
      widgetFunc: (props) => <Feedback {...props} />,
    },
    {
      widgetName: "ConsumerProducts",
      widgetFunc: (props) => <ConsumerProducts {...props} />,
    },
    {
      widgetName: "EtransferOptions",
      widgetFunc: (props) => <EtransferOptions {...props} />,
    },
    {
      widgetName: "AutodespositOptions",
      widgetFunc: (props) => <AutodespositOptions {...props} />,
    },
    {
      widgetName: "RequestMoneyOptions",
      widgetFunc: (props) => <RequestMoneyOptions {...props} />,
    },
    {
      widgetName: "IntlTransfersOptions",
      widgetFunc: (props) => <IntlTransfersOptions {...props} />,
    },
    {
      widgetName: "EtransferSecurityOptions",
      widgetFunc: (props) => <EtransferSecurityOptions {...props} />,
    },
    {
      widgetName: "EtransferSupport",
      widgetFunc: (props) => <LinkList {...props} />,
      props: {
        options: [
          {
            text: "Browse FAQs",
            url:
              "https://www.interac.ca/en/consumers/support/faq-consumers/#faq-interac-e-transfer",
            id: 1,
          },
          {
            text: "Support Form",
            url:
              "https://www.interac.ca/en/consumers/support/interac-e-transfer-customer-support-form/",
            id: 2,
          },
          {
            text: "Understanding Fees",
            url: "https://www.interac.ca/en/consumers/support/understanding-fees/",
            id: 3,
          },
          {
            text: "Contact Us",
            url: "https://www.interac.ca/en/contact-us/",
            id: 4,
          },
        ],
      },
    },
    {
      widgetName: "DebitOptions",
      widgetFunc: (props) => <DebitOptions {...props} />,
    },
    {
      widgetName: "ContactlessPaymentsOptions",
      widgetFunc: (props) => <ContactlessPaymentsOptions {...props} />,
    },
    {
      widgetName: "EcommercePaymentsOptions",
      widgetFunc: (props) => <EcommercePaymentsOptions {...props} />,
    },
    {
      widgetName: "TransitOpenPaymentsOptions",
      widgetFunc: (props) => <TransitOpenPaymentsOptions {...props} />,
    },
    {
      widgetName: "ApplePayOptions",
      widgetFunc: (props) => <ApplePayOptions {...props} />,
    },
    {
      widgetName: "GooglePayOptions",
      widgetFunc: (props) => <GooglePayOptions {...props} />,
    },
    {
      widgetName: "SamsungPayOptions",
      widgetFunc: (props) => <SamsungPayOptions {...props} />,
    },
    {
      widgetName: "OnlinePaymentsOptions",
      widgetFunc: (props) => <OnlinePaymentsOptions {...props} />,
    },
    {
      widgetName: "AbmWithdrawalsOptions",
      widgetFunc: (props) => <AbmWithdrawalsOptions {...props} />,
    },
    {
      widgetName: "DebitSecurity",
      widgetFunc: (props) => <LinkList {...props} />,
      props: {
        options: [
          {
            text: "Transaction Limits",
            url:
              "https://www.interac.ca/en/consumers/security/interac-debit/transaction-limits/",
            id: 1,
          },
          {
            text: "Zero Liability Policy",
            url:
              "https://www.interac.ca/en/consumers/security/interac-debit/zero-liability-policy/",
            id: 2,
          },
        ],
      },
    },
    {
      widgetName: "DebitSupport",
      widgetFunc: (props) => <LinkList {...props} />,
      props: {
        options: [
          {
            text: "Browse FAQs",
            url:
              "https://www.interac.ca/en/consumers/support/faq-consumers/#faq-interac-debit-interac-flash",
            id: 1,
          },
          {
            text: "Understanding Fees",
            url:
              "https://www.interac.ca/en/consumers/support/understanding-fees/",
            id: 2,
          },
          {
            text: "Contact Us",
            url:
              "https://www.interac.ca/en/contact-us/",
            id: 3,
          },
        ],
      },
    },
    {
      widgetName: "BusinessProducts",
      widgetFunc: (props) => <BusinessProducts {...props} />,
    },
    {
      widgetName: "EtransferOptionsBus",
      widgetFunc: (props) => <EtransferOptionsBus {...props} />,
    },
    {
      widgetName: "EufOptionsBus",
      widgetFunc: (props) => <EufOptionsBus {...props} />,
    },
    {
      widgetName: "AutodepositOptionsBus",
      widgetFunc: (props) => <AutodepositOptionsBus {...props} />,
    },
    {
      widgetName: "RequestMoneyOptionsBus",
      widgetFunc: (props) => <RequestMoneyOptionsBus {...props} />,
    },
    {
      widgetName: "BulkDisbursementsOptions",
      widgetFunc: (props) => <BulkDisbursementsOptions {...props} />,
    },

    {
      widgetName: "DebitOptionsBus",
      widgetFunc: (props) => <DebitOptionsBus {...props} />,
    },
    {
      widgetName: "ContactlessOptionsBus",
      widgetFunc: (props) => <ContactlessOptionsBus {...props} />,
    },
    {
      widgetName: "MobileOptionsBus",
      widgetFunc: (props) => <MobileOptionsBus {...props} />,
    },
    {
      widgetName: "OnlineOptionsBus",
      widgetFunc: (props) => <OnlineOptionsBus {...props} />,
    },
    {
      widgetName: "AbmOptionsBus",
      widgetFunc: (props) => <AbmOptionsBus {...props} />,
    },
    {
      widgetName: "PaymentSolutions",
      widgetFunc: (props) => <LinkList {...props} />,
      props: {
        options: [
          {
            text: "Benefits",
            url:
              "https://www.interac.ca/en/business/how-it-works/benefits/",
            id: 1,
          },
          {
            text: "Our Role",
            url:
              "https://www.interac.ca/en/business/how-it-works/role/",
            id: 2,
          },
          {
            text: "Find an Acquirer",
            url: "https://www.interac.ca/en/business/how-it-works/find-an-acquirer/",
            id: 3,
          },
        ],
      },
    },
    {
      widgetName: "Careers",
      widgetFunc: (props) => <LinkList {...props} />,
      props: {
        options: [
          {
            text: "Life at Interac",
            url:
              "https://www.interac.ca/en/about/careers/life-at-interac/",
            id: 1,
          },
          {
            text: "Company History",
            url:
              "https://www.interac.ca/en/about/our-company/history/",
            id: 2,
          },
          {
            text: "Diversity & Inclusion",
            url: "https://www.interac.ca/en/about/our-people/diversity-and-inclusion/",
            id: 3,
          },
          {
            text: "Job Postings ",
            url: "https://interac.wd3.myworkdayjobs.com/Interac",
            id: 4,
          },
        ],
      },
    },
    {
      widgetName: "OurSolutions",
      widgetFunc: (props) => <LinkList {...props} />,
      props: {
        options: [
          {
            text: "INTERAC e-Transfer",
            url: "https://www.interac.ca/en/business/our-solutions/interac-e-transfer/",
            id: 1,
          },
          {
            text: "INTERAC Debit",
            url: "https://www.interac.ca/en/business/our-solutions/interac-debit/",
            id: 2,
          },
          {
            text: "INTERAC Flash",
            url: "https://www.interac.ca/en/business/our-solutions/interac-flash/",
            id: 3,
          },
          {
            text: "INTERAC Debit on Mobile",
            url: "https://www.interac.ca/en/business/our-solutions/interac-debit-on-mobile/",
            id: 4,
          },
          {
            text: "INTERAC Debit for In-App & In-Browser Payments ",
            url: "https://www.interac.ca/en/business/our-solutions/interac-for-in-app-in-browser-payments/",
            id: 5,
          },
          {
            text: "INTERAC Cash",
            url: "https://www.interac.ca/en/business/our-solutions/interac-cash/",
            id: 5,
          },
          {
            text: "INTERAC Online",
            url: "https://www.interac.ca/en/business/our-solutions/interac-online/",
            id: 6,
          },
        ],
      },
    },
    {
      widgetName: "SafetySecurity",
      widgetFunc: (props) => <LinkList {...props} />,
      props: {
        options: [
          {
            text: "Safety at point-of-sale checkout",
            url: "https://www.interac.ca/en/business/safety-and-security/interac-debit/",
            id: 1,
          },
          {
            text: "The security behind a money transfer",
            url: "https://www.interac.ca/en/business/safety-and-security/interac-e-transfer/",
            id: 2,
          },
          {
            text: "Point-of-Purchase Integrity Checklist",
            url: "https://www.interac.ca/en/business/safety-and-security/point-of-purchase-integrity-checklist/",
            id: 3,
          },
        ],
      },
    },
    {
      widgetName: "BusinessSupport",
      widgetFunc: (props) => <LinkList {...props} />,
      props: {
        options: [
          {
            text: "Report a problem with a service provider",
            url: "https://www.interac.ca/en/business/code-of-conduct/",
            id: 1,
          },
          {
            text: "Browse FAQs",
            url: "https://www.interac.ca/en/business/support/business-faqs/",
            id: 2,
          },
          {
            text: "Learn about out solutions fee structure",
            url: "https://www.interac.ca/en/business/support/understanding-fees/",
            id: 3,
          },
          {
            text: "Point-of-Sale Materials ",
            url: "https://www.interac.ca/en/business/point-sale-materials/",
            id: 4,
          },
          {
            text: "Contact Us",
            url: "https://www.interac.ca/en/contact-us/",
            id: 5,
          },
        ],
      },
    },
  ],
};

export default config;